const langNewsArticle = {
	read: {
		tag: 'news.article.read',
		fr: 'Ouvrir',
		en: 'Open',
	},
	Actualités: {
		tag: 'news.article.news',
		fr: 'Actualités',
		en: 'News',
	},
	Newsletters: {
		tag: 'news.article.newsletters',
		fr: 'Newsletters',
		en: 'Newsletters',
	},
	'Communiqués de presse': {
		tag: 'news.article.media',
		fr: 'Communiqués de presse',
		en: 'Press releases',
	},
	'Évolutions réglementaires': {
		tag: 'news.article.regulatory',
		fr: 'Évolutions réglementaires',
		en: 'Regulatory changes',
	},
};

export default langNewsArticle;
